// extracted by mini-css-extract-plugin
export var md = "_43-4";
export var semantic = "_43-5";
export var sm = "_43-3";
export var text = "_43-6";
export var toggleInput = "_43-0";
export var toggleSwitch = "_43-1";
export var xs = "_43-2";